var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-home"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip-home)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home-2",
    "data-name": "Icon awesome-home",
    d: "M16.793,9.646,5.75,19.306V29.732a.989.989,0,0,0,.958,1.018l6.712-.018a.99.99,0,0,0,.954-1.018V23.625a.989.989,0,0,1,.958-1.018h3.833a.989.989,0,0,1,.958,1.018v6.084a1.051,1.051,0,0,0,.28.722.931.931,0,0,0,.679.3l6.71.02a.989.989,0,0,0,.958-1.018V19.3L17.709,9.646A.7.7,0,0,0,16.793,9.646Zm17.444,6.566-5.007-4.384V3.017a.742.742,0,0,0-.719-.763H25.156a.742.742,0,0,0-.719.763V7.636L19.075,2.95a2.746,2.746,0,0,0-3.654,0L.26,16.212a.8.8,0,0,0-.1,1.075l1.527,1.972a.707.707,0,0,0,.486.275.691.691,0,0,0,.527-.171L16.793,7.038a.7.7,0,0,1,.916,0L31.8,19.363a.69.69,0,0,0,1.012-.1l1.527-1.972a.8.8,0,0,0,.16-.561.778.778,0,0,0-.262-.516Z",
    transform: "translate(0.001 -2.254)",
    fill: "#f6f6f6"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.42c79148.svg";
export { ForwardRef as ReactComponent };